import VwSonucIzlemeTanimDTO from "src/models/Settings/Generals/VwSonucIzlemeTanimDTO";
import api from "../core/api";
import { ApiResponse } from "../core";

const controllerName = "SonucIzlemeTanim";

const SonucIzlemeTanimApi = api.injectEndpoints({
    endpoints: (builder) => ({
        SonucIzlemeTanimListesi: builder.query<Array<VwSonucIzlemeTanimDTO>, void>({
            query: (request) => {
                return {
                    url: controllerName + "/SonucIzlemeTanimListesi",
                    method: "GET",
                }
            },
             providesTags: ["SonucIzlemeTanimlari"]
        }),
        SonucIzlemeTanimEkle: builder.mutation<ApiResponse<VwSonucIzlemeTanimDTO>,VwSonucIzlemeTanimDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/SonucIzlemeTanimEkle",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["SonucIzlemeTanimlari"]
        }),
        SonucIzlemeTanimSil: builder.mutation<boolean, { id: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/SonucIzlemeTanimSil",
                    method: "DELETE",
                    params: request
                }
            },
            invalidatesTags: ["SonucIzlemeTanimlari"]
        }),
        SonucIzlemeTanimDuzenle: builder.mutation<ApiResponse<VwSonucIzlemeTanimDTO>, VwSonucIzlemeTanimDTO>({
            query: (request) => {
                return {
                    url: controllerName + "/SonucIzlemeTanimDuzenle",
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["SonucIzlemeTanimlari"]
        }),

    })
});

export const {
    useSonucIzlemeTanimListesiQuery,
    useSonucIzlemeTanimEkleMutation,
    useSonucIzlemeTanimSilMutation,
    useSonucIzlemeTanimDuzenleMutation,
} = SonucIzlemeTanimApi;